import { Spin, Typography } from "antd";
import styles from "./PatientSyncNotice.module.scss";

const { Text } = Typography;

/** Sidebar card shown in place of the empty state while a first EHR pull is outstanding. */
export default function PatientSyncNotice() {
  return (
    <div className={styles.card}>
      <div className={styles.head}>
        <Spin size="small" />
        <Text className={styles.title}>Setting up your patient list</Text>
      </div>
      <Text type="secondary" className={styles.body}>
        We're pulling today's schedule from your EHR. This usually takes a few minutes, and your patients will appear
        here automatically.
      </Text>
      <Text type="secondary" className={`${styles.body} ${styles.bodySpaced}`}>
        You can add a patient manually any time.
      </Text>
    </div>
  );
}
